import React, { useContext, useState } from "react";
import { Polygon } from "@react-google-maps/api";
import styled from "styled-components";
import MapDownloadDataModal from "../mapDownloadDataModal/MapDownloadDataModal";
import { DownloadModalTypes } from "../../../../../constants/WebMap";
import { WebMapContext } from "../../../../../pages/sections/web-map/WebMapGoogleMap";

const SelectButton = styled.button`
  padding: 8px 20px;
  background-color: #006f35;
  color: white;
  border: none;
  border-radius: 40px;
  font: normal normal normal 18px/22px Open Sans;
  cursor: pointer;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #388e3c;
  }
`;

const CircleToolControls = styled.div`
  position: absolute;
  top: 43px;
  right: 16px;
`;

const DownloadPolygonTool = () => {
  const {
    toolMarkers,
  } = useContext(WebMapContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {toolMarkers.length > 0 && (
        <Polygon
          path={toolMarkers}
          options={{
            strokeColor: "green",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "green",
            fillOpacity: 0.5,
            zIndex: 999,
          }}
        />
      )}
      {toolMarkers?.length > 2 && (
        <CircleToolControls>
          <SelectButton
            onClick={() => {
              setIsModalOpen(true);
            }}
          >
            Select the Polygon
          </SelectButton>
        </CircleToolControls>
      )}
      {isModalOpen ? (
        <MapDownloadDataModal
          type={DownloadModalTypes.POLYGON}
          isOpen
          onClose={() => setIsModalOpen(false)}
        />
      ) : null}
    </>
  );
};

export default DownloadPolygonTool;
